import React, { Component } from "react";
import Formatters from "../../utils/Formatters"
import Calculation from '../../utils/Calculation';
import MobileChecker from "../../utils/MobileChecker";

const defaultProps = {
  fullValue: 0, // 100%
  currentValue: 0, // progress bar
  partialValue: 0, // partial progress bar
}

class ProgressBar extends Component {
  totalLength = () => {
    if (!this.progressBar || this.progressBar.getTotalLength === undefined) return 0;
    return Math.floor(this.progressBar.getTotalLength());
  }

  partialAmountOffset = () => {
    if (!this.partialAmount || this.partialAmount.getBBox === undefined) return 0;
    return Math.floor(this.partialAmount.getBBox().width / 2);
  }

  // val = current | partial
  getPercentage = val => Calculation.percentage({ part: val, full: this.props.fullValue });

  progressBarValue = (val, reverse = false) => {
    const percentage = this.getPercentage(val);
    if (percentage > 100) return 0;
    if (reverse) return this.totalLength() + ((percentage / 100) * this.totalLength());

    return this.totalLength() - ((percentage / 100) * this.totalLength());
  }

  svgWidth = () => {
    if (MobileChecker()) return 250;
    return 310;
  }

  middleXVal = () => {
    const percentage = this.getPercentage(this.props.partialValue);
    // hardcoded min/max val based on the current svg width
    const min = 24;
    const max = 251;
    let multiplier = .5;
    if (percentage < 35) multiplier = .6;
    if (percentage < 25) multiplier = .7;
    if (percentage < 15) multiplier = .8;
    if (percentage < 5) multiplier  = 1;
    if (percentage < 3) multiplier  = 1.3;
    if (percentage < 2) multiplier  = 2;


    return (max - (((percentage * multiplier) / 100) * max) + min);
  }

  render() {
    const { currentValue, partialValue } = this.props;
    return(
      <svg width={this.svgWidth()} height="49" viewBox="0 0 310 49" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid="progress-bar">
        <text fill="#8082A9" className='_whiteSpace_pre _fontWeight_bold'>
          <tspan x="285.225" y="15" className='byline _fontSize--xsmall'>100%</tspan>
        </text>
        <text fill="#8082A9" className='_whiteSpace_pre _fontWeight_bold'>
          <tspan x="0.219727" y="15" className='byline _fontSize--xsmall'>0%</tspan>
        </text>

        <line x1="31" y1="12" x2="269" y2="12" stroke="#E8E9FF" strokeWidth="24" strokeLinecap="round"/>

        <g width="238">
          <line
            ref={(ref) => this.progressBar = ref}
            x1="31"y1="12" x2="269" y2="12"
            stroke="#F8C89C"
            strokeWidth="18"
            strokeLinecap="round"
            strokeDasharray={this.totalLength()}
            strokeDashoffset={this.progressBarValue(currentValue)}
          />

          <path
            d="M31 12L269 12"
            stroke="#F59943"
            strokeLinecap="round"
            strokeWidth="18"
            strokeDasharray={this.totalLength()}
            strokeDashoffset={this.progressBarValue(partialValue, true)}
          />

          <line
            x1={this.middleXVal()}
            x2={this.middleXVal()}
            y1="21"
            y2="33"
            stroke="#F59943"
            strokeWidth="2"
          />
          <text fill="white" className="_whiteSpace_pre _fontWeight_bold">
            <tspan x={this.middleXVal() - 8} y="15" className="byline _fontSize--small" data-testid="bar-percentage-owed">{this.getPercentage(partialValue)}%</tspan>
          </text>
          <text fill="#E97001" className="_whiteSpace_pre _fontWeight_bold">
            <tspan ref={(ref) => this.partialAmount = ref} x={this.middleXVal() - this.partialAmountOffset()} y="44.6" className="byline _fontSize--small">
              {Formatters.currency({ amount: partialValue })}
            </tspan>
          </text>
        </g>
      </svg>
    );
  }
}

ProgressBar.defaultProps = defaultProps;
export default ProgressBar;



// WEBPACK FOOTER //
// ./src/features/shared/components/charts/ProgressBar.js